import React from 'react'
import { BackIcon } from '../../components/icons'
import Logo from '../../components/Logo'

export default function CoverHeader(props) {
  const { header } = props

  return (
    <div className={`${header} cover-header`}>
      {header === 'back' ? (
        <header className='cover-back'>
          <BackIcon onClick={() => props.history.go(-1)} className='return-icon' />
          <div className='center'>
            <Logo />
          </div>
        </header>
      ) : (
        <header className='cover-icon'>
          <Logo onClick={() => props.history.push('/')} />
        </header>
      )}
    </div>
  )
}
